module.exports = __webpack_public_path__ + "static/media/parts_12.9d570a43.svg";